import { buildGlobalReferenceContext } from '../../../context/buildGlobalReferenceContext.mjs';

const [CheckboxContextProvider, useCheckboxContext] = buildGlobalReferenceContext("Checkbox", {
  disabled: false,
  size: "default"
});

export { CheckboxContextProvider, useCheckboxContext };
//# sourceMappingURL=context.mjs.map
